import React from 'react';
import PropTypes from 'prop-types';
import SelectBox from '@welldev-group/rcl-select-box';
import { countries } from 'country-data';

const CountrySelector = props => {
  const countryList = countries.all
    .filter(country => country.status === 'assigned')
    .map(country => ({
      value: country.alpha2,
      label: country.name,
    }));

  const {
    title,
    disabled,
    error,
    placeholder,
    required,
    touched,
    onChange,
    value,
    menuPlacement,
    maxMenuHeight,
  } = props;

  const findLabelValue = (options, value) => {
    const selectedOption = options.find(option => option.value === value);
    if (selectedOption) {
      return selectedOption;
    }

    return null;
  };

  return (
    <SelectBox
      className="credit-card-details__billing-form__country-selector"
      errorMsg={error}
      options={countryList}
      label={title}
      disabled={disabled}
      onChange={selectedOption =>
        selectedOption && onChange(selectedOption.value)
      }
      value={findLabelValue(countryList, value)}
      size="normal"
      width="full"
      placeholderText={placeholder}
      required={required}
      touched={touched}
      menuPlacement={menuPlacement}
      maxMenuHeight={maxMenuHeight}
    />
  );
};

CountrySelector.defaultProps = {
  error: null,
  value: null,
  disabled: false,
  required: true,
  placeholder: null,
  touched: true,
  maxMenuHeight: 300,
  menuPlacement: 'bottom',
};

CountrySelector.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  error: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  disabled: PropTypes.bool,
  touched: PropTypes.bool,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  maxMenuHeight: PropTypes.number,
  menuPlacement: PropTypes.oneOf(['bottom', 'auto', 'top']),
};

export default CountrySelector;
